import React from 'react'
import defineMessages from '../Messages/index'
import { FormattedMessage } from 'react-intl'

export const editRecipePageTitle = (
  <FormattedMessage {...defineMessages.editRecipeTitle} />
)
